import * as React from "react";
function SvgForum(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M13 5.5c5 0 9 2.86 9 6.38a4.74 4.74 0 01-.42 1.92 7.53 7.53 0 00-1.08-.05c-4.09 0-7.5 1.84-8.6 4.41a11.78 11.78 0 01-3.31-.75L5.5 20.5v-5.13A5.11 5.11 0 014 11.88C4 8.36 8 5.5 13 5.5zm15 14.77a3.79 3.79 0 01-1.5 2.83v3.4l-2.2-2.15a10.69 10.69 0 01-3.8.68C16.36 25 13 22.9 13 20.27s3.36-4.77 7.5-4.77 7.5 2.13 7.5 4.77z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgForum);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
